import axios from 'src/utils/axiosHelper';
import { SET_ALERT } from 'src/actions/alertAction';
import { message } from 'src/constantsMessage';
import helperAxios from 'src/utils/helperAxios';

export const CONTACT_US_SUCCESS = '@contact/contact-us';
export const CONTACT_US_ERROR = '@contact/contact-us-error';
export const CONTACT_US_EMPTY = '@contact/contact-us-empty';
export const CONTACT_SUPPORT_SUCCESS = '@contact/contact-support';
export const CONTACT_SUPPORT_ERROR = '@contact/contact-support-error';
export const CONTACT_SUPPORT_EMPTY = '@contact/contact-support-empty';
export const LOADER = '@contact/loader';

const handleMove = () => {
  window.open('https://www.precisa.in');
};

export function contactUs(
  values,
  flag,
  attribute,
  captchaText,
  captchaRequestUUID
) {
  const url = `/api/v3/supportTicket/contactus?flag=${flag}`;
  const bodyData = {
    fullName: values.fullName,
    email: values.email,
    phoneNumber: values.phoneNumber,
    companyName: values.companyName,
    industry: values.industry === 'Other' ? values.industry1 : values.industry,
    message: values.message,
    ...(captchaText && captchaRequestUUID
      ? { captchaRequestUUID, captchaText }
      : {})
  };
  attribute &&
    attribute !== '' &&
    (bodyData.googleAdInfo = attribute
      .slice(1)
      .split('&')
      .reduce((obj, searchStr, index) => {
        let strList = searchStr.split('=');
        if (strList[0] === 'flag') return obj;
        if (strList[0] === 'campaignid') obj.campaignId = strList[1];
        else if (strList[0] === 'adgroupid') obj.adGroupId = strList[1];
        else obj[strList[0]] = strList[1];
        return obj;
      }, {}));

  const request = helperAxios(url, 'post', bodyData);

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        dispatch({
          type: CONTACT_US_SUCCESS,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: CONTACT_US_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}
export const contactUsEmpty = () => {
  return dispatch => {
    dispatch({ type: CONTACT_US_EMPTY });
  };
};

export function contactSupport(values, captchaText, captchaRequestUUID) {
  const url = `/api/v3/supportTicket/support`;
  const bodyData = {
    fullName: values.fullName,
    email: values.email,
    phoneNumber: values.phoneNumber,
    subject: values.subject,
    message: values.message,
    ...(captchaText && captchaRequestUUID
      ? { captchaRequestUUID, captchaText }
      : {})
  };
  const request = helperAxios(url, 'post', bodyData);

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        dispatch({
          type: CONTACT_SUPPORT_SUCCESS,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: CONTACT_SUPPORT_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}
export const contactSupportEmpty = () => {
  return dispatch => {
    dispatch({ type: CONTACT_SUPPORT_EMPTY });
  };
};
